const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

const getOS = () => {
  const ua = navigator.userAgent;
  if (ua.includes("Win")) return "Windows";
  if (ua.includes("Mac")) {
    const match = ua.match(/Mac OS X (\d+[._]\d+)/);
    if (match) return `macOS ${match[1].replace("_", ".")}`;
    return "macOS";
  }
  if (ua.includes("iPhone") || ua.includes("iPad")) {
    const match = ua.match(/OS (\d+_\d+)/);
    if (match) return `iOS ${match[1].replace("_", ".")}`;
    return "iOS";
  }
  if (ua.includes("Android")) {
    const match = ua.match(/Android (\d+\.?\d*)/);
    if (match) return `Android ${match[1]}`;
    return "Android";
  }
  if (ua.includes("Linux")) return "Linux";
  return "Unknown";
};

const getOSVersion = () => {
  const ua = navigator.userAgent;

  // Windows
  if (ua.includes("Windows NT 10.0")) {
    if (navigator.userAgentData && navigator.userAgentData.platform === "Windows") {
      try {
        const platformVersion = navigator.userAgentData.platformVersion || "";
        const majorVersion = parseInt(platformVersion.split(".")[0]);
        // Windows 11 reports platformVersion >= 13
        if (majorVersion >= 13) return "11";
        return "10";
      } catch {
        return "10";
      }
    }
    return "10";
  }

  if (ua.includes("Windows NT 6.3")) return "8.1";
  if (ua.includes("Windows NT 6.2")) return "8";
  if (ua.includes("Windows NT 6.1")) return "7";
  if (ua.includes("Windows NT 6.0")) return "Vista";

  // macOS
  if (ua.includes("Mac OS X")) {
    const match = ua.match(/Mac OS X (\d+[._]\d+[._]?\d*)/);
    if (match) {
      const version = match[1].replace(/_/g, ".");
      return version;
    }
    return "macOS";
  }

  // iOS
  if (ua.includes("iPhone") || ua.includes("iPad")) {
    const match = ua.match(/OS (\d+_\d+)/);
    if (match) return match[1].replace("_", ".");
    return "iOS";
  }

  // Android
  if (ua.includes("Android")) {
    const match = ua.match(/Android (\d+\.?\d*\.?\d*)/);
    if (match) return match[1];
    return "Android";
  }

  return "Unknown";
};

const getBrowser = () => {
  const ua = navigator.userAgent;
  if (navigator.brave && typeof navigator.brave.isBrave === 'function') return "Brave";
  if (ua.includes("Brave")) return "Brave";
  if (/(Brave|brave)/.test(ua)) return "Brave";
  if (ua.includes("Vivaldi")) return "Vivaldi";
  if (ua.includes("OPR/") || ua.includes("Opera/")) return "Opera";
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
  if (ua.includes("Firefox")) return "Firefox";
  return "Unknown";
};

const getBrowserVersion = () => {
  const ua = navigator.userAgent;
  let match;
  if (navigator.brave && typeof navigator.brave.isBrave === 'function') {
    match = ua.match(/Chrome\/(\d+\.\d+)/);
    return match ? match[1] : "Unknown";
  }
  if (ua.includes("Vivaldi")) {
    match = ua.match(/Vivaldi\/(\d+\.\d+)/);
    if (match) return match[1];
  }
  if (ua.includes("OPR/")) {
    match = ua.match(/OPR\/(\d+\.\d+)/);
    if (match) return match[1];
  }
  if (ua.includes("Edg/")) {
    match = ua.match(/Edg\/(\d+\.\d+)/);
    if (match) return match[1];
  }
  if (ua.includes("Chrome")) {
    match = ua.match(/Chrome\/(\d+\.\d+)/);
    if (match) return match[1];
  }
  if (ua.includes("Safari")) {
    match = ua.match(/Version\/(\d+\.\d+)/);
    if (match) return match[1];
  }
  if (ua.includes("Firefox")) {
    match = ua.match(/Firefox\/(\d+\.\d+)/);
    if (match) return match[1];
  }
  return "Unknown";
};

const getDeviceBrand = () => {
  const ua = navigator.userAgent;
  if (ua.includes("iPhone")) return "Apple";
  if (ua.includes("iPad")) return "Apple";
  if (ua.includes("Mac")) return "Apple";
  if (ua.includes("Samsung")) return "Samsung";
  if (ua.includes("Pixel")) return "Google Pixel";
  if (ua.includes("OnePlus")) return "OnePlus";
  if (ua.includes("Xiaomi")) return "Xiaomi";
  if (ua.includes("Redmi")) return "Redmi";
  if (ua.includes("OPPO")) return "OPPO";
  if (ua.includes("Vivo")) return "Vivo";
  if (ua.includes("Motorola")) return "Motorola";
  if (ua.includes("Nokia")) return "Nokia";
  if (ua.includes("Huawei")) return "Huawei";
  if (ua.includes("LG")) return "LG";
  if (ua.includes("HTC")) return "HTC";
  if (typeof navigator !== 'undefined') {
    const deviceType = getDeviceType();
    if (deviceType === "desktop") {
      if (ua.includes("Windows")) return "Windows PC";
      if (ua.includes("Mac")) return "Apple Mac";
      if (ua.includes("Linux")) return "Linux PC";
      if (ua.includes("X11")) return "Linux PC";
    }
  }
  return "Unknown";
};

const getConnectionType = () => {
  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;
  if (connection) {
    return connection.effectiveType || connection.type || "unknown";
  }
  return "unknown";
};

const getScreenResolution = () => {
  if (window && window.screen) {
    return `${window.screen.width}x${window.screen.height}`;
  }
  return "unknown";
};

export const collectDeviceInfo = () => {
  try {
    const browser = getBrowser();
    const browserVersion = getBrowserVersion();
    const osVersion = getOSVersion();
    const deviceBrand = getDeviceBrand();
    const deviceInfo = {
      device_type: getDeviceType(),
      device_brand: deviceBrand,
      os: getOS(),
      os_version: osVersion,
      browser: browser,
      browser_version: browserVersion,
      connection_type: getConnectionType(),
      screen_resolution: getScreenResolution(),
    };
    console.log("Collected Device Info:", deviceInfo);
    return deviceInfo;
  } catch (err) {
    console.error("Error collecting device info:", err);
    return {
      device_type: "unknown",
      device_brand: "unknown",
      os: "unknown",
      os_version: "unknown",
      browser: "unknown",
      browser_version: "unknown",
      connection_type: "unknown",
      screen_resolution: "unknown",
    };
  }
};

export default collectDeviceInfo;
